import {
  TableColumns,
  TableRow,
  TableRowCellsData,
} from 'app/components/Common/CommonTable/type';
import { SymbolOptionChainDataType } from 'types/ApiServicesTypes';
import { Theme } from '@mui/material';
import { formatNumber } from 'utils/GenericFunctions';
import {
  PositionBaseDataType,
  PositionData,
} from '../Simulator/OptionChain/types';
export const createOptionTableRowsAllGreeks = (
  optionChainData: Record<string, SymbolOptionChainDataType>,
  handleOptionClick: (
    position: PositionBaseDataType,
    contractType: string,
    strike: string,
  ) => void,
  currentStrike: number,
  positions: PositionData,
  isCE: boolean,
  date: string,
  theme: Theme,
): { rows: TableRow<SymbolOptionChainDataType>[]; columns: TableColumns[] } => {
  const rows: TableRow<SymbolOptionChainDataType>[] = [];
  let rowCellsData: TableRowCellsData[] = [];
  const columns: TableColumns[] = [
    { text: 'OI', align: 'center' },
    { text: 'Volume', align: 'center' }, // <-- Add for CE
    { text: 'Delta', align: 'center' },
    { text: 'Theta', align: 'center' },
    { text: 'Vega', align: 'center' },
    { text: 'Gamma', align: 'center' },
    { text: 'IV', align: 'center' },
    { text: 'LTP', align: 'center' },
    { text: 'Strike', align: 'center' },
    { text: 'LTP', align: 'center' },
    { text: 'IV', align: 'center' },
    { text: 'Gamma', align: 'center' },
    { text: 'Vega', align: 'center' },
    { text: 'Theta', align: 'center' },
    { text: 'Delta', align: 'center' },
    { text: 'Volume', align: 'center' }, // <-- Add for PE (before or after PE OI)
    { text: 'OI', align: 'center' },
  ];

  if (!optionChainData) return { rows, columns };

  // // eslint-disable-next-line no-console
  // console.log('optionchain data', optionChainData);

  const strikePrices = Object.keys(optionChainData);
  const maxOI = Math.max(
    ...Object.values(optionChainData).map(row => row.CE.oi ?? 0, 0),
    ...Object.values(optionChainData).map(row => row.PE.oi ?? 0, 0),
  );

  const OIBar = ({ value, max, color = '#8884d8' }) => (
    <div style={{ width: 60, height: 8, background: '#eee', borderRadius: 4 }}>
      <div
        style={{
          width: `${(value / max) * 100}%`,
          height: '100%',
          background: color,
          borderRadius: 4,
        }}
      />
    </div>
  );

  strikePrices.map((keyStrike: string) => {
    const strike = Number(keyStrike);
    const strikeDiff = Number(strikePrices[1]) - Number(strikePrices[0]);
    // const atmStrike = Math.round(currentStrike / strikeDiff) * strikeDiff;
    const atmStrike = strikePrices
  .map(Number)
  .reduce((prev, curr) =>
    Math.abs(curr - currentStrike) < Math.abs(prev - currentStrike) ? curr : prev
  );
    const isATM = atmStrike === strike;
    // eslint-disable-next-line no-console
    console.log('atm data', isATM, atmStrike, strike, strikeDiff);
    const isITM = atmStrike >= strike;
    const isOTM = atmStrike <= strike;
    const cePositions = positions?.[`CE_${keyStrike}`];
    const pePositions = positions?.[`PE_${keyStrike}`];
    const cePositionCandleWise = cePositions?.positionCandleWise;
    const pePositionCandleWise = pePositions?.positionCandleWise;
    const rowData = optionChainData[keyStrike];
    rowCellsData = [
      // CE OI with sparkline
      {
        content: (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <span>
              {rowData.CE.oi ? formatNumber(rowData.CE.oi / 100000) + 'L' : '0'}
            </span>
            <OIBar
              value={rowData.CE.oi ?? 0}
              max={maxOI}
              color={theme.component.optionChainColors.oiCeBg}
            />
          </div>
        ),
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isITM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // CE Volume
      {
        content: (
          <span>
            {rowData.CE.volume
              ? formatNumber(rowData.CE.volume / 100000) + 'L'
              : '-'}
          </span>
        ),
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isITM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // CE Delta
      {
        content:
          rowData.CE.delta !== undefined ? rowData.CE.delta.toFixed(2) : '-',
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isITM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // CE Theta
      {
        content:
          rowData.CE.theta !== undefined ? rowData.CE.theta.toFixed(2) : '-',
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isITM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // CE Vega
      {
        content:
          rowData.CE.vega !== undefined ? rowData.CE.vega.toFixed(2) : '-',
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isITM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // CE Gamma
      {
        content:
          rowData.CE.gamma !== undefined ? rowData.CE.gamma.toFixed(4) : '-',
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isITM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // CE IV
      {
        content: rowData.CE.iv !== undefined ? rowData.CE.iv.toFixed(2) : '-',
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isITM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // CE LTP
      {
        content:
          rowData.CE.close !== undefined ? rowData.CE.close.toFixed(2) : '-',
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isITM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // Strike
      {
        content: strike,
        fontWeight: 700,
        align: 'center',
        backgroudColor: isATM ? theme.component.optionChainColors.atmBg : '',
      },
      // PE LTP
      {
        content:
          rowData.PE.close !== undefined ? rowData.PE.close.toFixed(2) : '-',
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isOTM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // PE IV
      {
        content: rowData.PE.iv !== undefined ? rowData.PE.iv.toFixed(2) : '-',
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isOTM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // PE Gamma
      {
        content:
          rowData.PE.gamma !== undefined ? rowData.PE.gamma.toFixed(4) : '-',
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isOTM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // PE Vega
      {
        content:
          rowData.PE.vega !== undefined ? rowData.PE.vega.toFixed(2) : '-',
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isOTM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // PE Theta
      {
        content:
          rowData.PE.theta !== undefined ? rowData.PE.theta.toFixed(2) : '-',
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isOTM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // PE Delta
      {
        content:
          rowData.PE.delta !== undefined ? rowData.PE.delta.toFixed(2) : '-',
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isOTM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // PE Volume
      {
        content: (
          <span>
            {rowData.PE.volume
              ? formatNumber(rowData.PE.volume / 100000) + 'L'
              : '-'}
          </span>
        ),
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isOTM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
      // PE OI with sparkline
      {
        content: (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <span>
              {rowData.PE.oi ? formatNumber(rowData.PE.oi / 100000) + 'L' : '0'}
            </span>
            <OIBar
              value={rowData.PE.oi ?? 0}
              max={maxOI}
              color={theme.component.optionChainColors.oiCeBg}
            />
          </div>
        ),
        align: 'center',
        backgroudColor: isATM
          ? theme.component.optionChainColors.atmBg
          : isOTM
          ? theme.component.optionChainColors.itmBg
          : '',
      },
    ];
    rows.push({
      rowCellsData,
      rowData,
      pt: 0.5,
      pb: 0.5,
      visibleOnHover: true,
    });
  });
  return { rows, columns };
};
